export default {
	methods:
	{
		openInstructorModal(event, item)
		{
			event && event.preventDefault();
			// console.log('openInstructorModal')
			this.$root.$emit('open-modal', {...item} );
		},
	}
}
